import { CLAIM_COUNT_QUESTION_ID } from '../../constants/domain-specific';
import { ClaimCount, updateApplied, updateClaimCount } from '../../slices/extraInfo';
import { AppDispatch } from '../../store';
import { Question } from '../../types/policy';

export const updateQuestionsAction = ({
  questions,
  isQuoteTillPayments,
  dispatch,
}: {
  isQuoteTillPayments: boolean;
  questions: Question[];
  dispatch: AppDispatch;
}) => {
  const claimCountQuestion = questions.find((q) => q.questionId === CLAIM_COUNT_QUESTION_ID);
  if (claimCountQuestion) {
    const { text } = claimCountQuestion.answer;

    if (text === 'true') {
      dispatch(updateClaimCount(ClaimCount.One));
      dispatch(updateApplied(false));
    }

    if (text === 'false' && isQuoteTillPayments) {
      dispatch(updateClaimCount(ClaimCount.Zero));
      dispatch(updateApplied(false));
    }
  }
};
